import React, {useState} from 'react';
import styles from './orderSummary.module.css';
import {connect} from 'react-redux';
import {
    StyledButton,
    StyledTextField,
    StyledFormGroup,
    StyledTypography,
} from './styledMaterialComponents';
import FormControl from '@material-ui/core/FormControl';
import {changeMonthForNumeral} from '../../utils/nounVariations';

const OrderSummary = ({
    subscriptionDetails,
    contactDetails,
    userDetails,
    sendDataToFirebase,
    monthlyPrice,
    totalPrice,
    checkPromotionCode,
    foundPromotionCode,
}) => {
    const [promotionCode, setPromotionCode] = useState('');
    return (
        <div className={styles.orderSummary}>
            {!userDetails && (
                <p className={styles.alert}>
                    Uwaga: Będąc niezalogowanym nie będziesz mógł zmienić
                    szczegółów swojej subskrypcji!
                </p>
            )}
            <p className={styles.alert}>
                Uwaga: Wysyłka zostanie zrealizowana po 25.09.2020 r.
            </p>
            <h3 className={styles.header}>Subskrypcja:</h3>
            <div className={styles.summaryContainer}>
                <p>
                    <b>Mieszanka Ziołowa</b> przez{' '}
                    {subscriptionDetails.subscriptionLength}{' '}
                    {changeMonthForNumeral(
                        subscriptionDetails.subscriptionLength,
                    )}
                    .
                </p>
                <p>
                    Cena: <b>{monthlyPrice}zł</b> x
                    {subscriptionDetails.subscriptionLength}
                </p>
            </div>
            {contactDetails.deliveryMethod === 'INPOST' ? (
                <div className={styles.summaryContainer}>
                    <p>
                        <b>Dostawa</b>
                    </p>
                    <p>
                        Cena miesięczna: <b>15.00zł</b>
                    </p>
                </div>
            ) : null}
            {subscriptionDetails.addBidon ? (
                <div className={styles.summaryContainer}>
                    <p>
                        <b>Termos</b>
                    </p>
                    <p>
                        {subscriptionDetails.subscriptionLength < 12 ? (
                            <>
                                Cena: <b>80.00zł</b>
                            </>
                        ) : (
                            <>
                                Cena:{' '}
                                <b>
                                    <s>80.00zł</s> ZA DARMO
                                </b>
                            </>
                        )}
                    </p>
                </div>
            ) : null}
            {subscriptionDetails.addInfuser ? (
                <div className={styles.summaryContainer}>
                    <p>
                        <b>Zaparzacz</b>
                    </p>
                    <p>
                        {subscriptionDetails.subscriptionLength < 3 ? (
                            <>
                                Cena: <b>10.00zł</b>
                            </>
                        ) : (
                            <>
                                Cena:{' '}
                                <b>
                                    <s>10.00zł</s> ZA DARMO
                                </b>
                            </>
                        )}
                    </p>
                </div>
            ) : null}

            <div className={styles.summaryTotal}>
                <p>
                    <b>Suma: {totalPrice.toFixed(2)}zł</b>
                </p>
            </div>
            <h3 className={styles.header}>Dane kontaktowe:</h3>
            <div className={styles.contactDetails}>
                <p>Imię: {contactDetails.name}</p>
                <p>Nazwisko: {contactDetails.surname}</p>
                <p>Adres: {contactDetails.adress}</p>
                <p>Miasto: {contactDetails.city}</p>
                <p>Kod pocztowy: {contactDetails.zipCode}</p>
                <p>Metoda dostawy {contactDetails.deliveryMethod}</p>
                {subscriptionDetails.deliveryMethod === 'INPOST' && (
                    <p>Kod inpost {contactDetails.inPostCode}</p>
                )}
            </div>
            <FormControl>
                <StyledFormGroup row={true}>
                    <StyledTypography>
                        {foundPromotionCode?.exist === false &&
                            'Kod nie został znaleziony'}
                        {foundPromotionCode?.exist === true &&
                            `Rabat ${foundPromotionCode.value}% został dodany`}
                    </StyledTypography>
                    <StyledTextField
                        value={promotionCode}
                        error={foundPromotionCode?.exist === false}
                        id="promotionCode"
                        label="Kod rabatowy"
                        variant="outlined"
                        onChange={event => {
                            setPromotionCode(event.target.value);
                        }}
                    />
                    <StyledButton
                        variant="contained"
                        onClick={() => checkPromotionCode(promotionCode)}
                        color="primary">
                        Dodaj Kod
                    </StyledButton>
                </StyledFormGroup>
                <StyledFormGroup>
                    <StyledButton
                        variant="contained"
                        onClick={sendDataToFirebase}
                        color="primary"
                        size="large">
                        Zaakceptuj i wyślij
                    </StyledButton>
                </StyledFormGroup>
            </FormControl>
        </div>
    );
};

const mapStateToProps = state => ({
    userDetails: state.auth.userDetails,
});

export default connect(mapStateToProps)(OrderSummary);
